/**
 * Возвращает отформатированное число в формате 000 000
 */
export const { format: formatNumber } = Intl.NumberFormat('ru');
